import { RatingState } from '~commons/common-types';

export const SET_RATING_STATE = 'SET_RATING_STATE' as const;
export const setRatingState = (payload: RatingState) => ({
  type: SET_RATING_STATE,
  payload,
});
